export * from './deviceInfo';
